import TextField, { TextFieldProps } from "@mui/material/TextField";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";

export const DebouncedTextField = ({
  value: initialValue,
  onChange,
  ...props
}: TextFieldProps) => {
  const [value, setValue] = useState(initialValue);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleUpdate = useCallback(
    debounce((event) => onChange && onChange(event), 500),
    [onChange],
  );

  useEffect(() => {
    console.log(initialValue);
    setValue(initialValue);
  }, [initialValue]);

  return (
    <TextField
      {...props}
      value={value}
      onChange={(event) => {
        setValue(event.target.value);
      }}
      onKeyDown={handleUpdate}
    />
  );
};
